import * as qs from 'qs';
import * as React from 'react';
import styled from 'styled-components';

import Button from '@material-ui/core/Button';
import PlayArrow from '@material-ui/icons/PlayArrow';
import Stop from '@material-ui/icons/Stop';
import ITeamState from "../redux/modules/team/state";

import {MouseEventHandler, TouchEventHandler} from "react";

interface IExternalProps {
    startTimer: (milliseconds:number, name:string) => void;
    stopTimer: (event:any) => void;

    disableStart: boolean;
    disableStop: boolean;
    forceShow: boolean;
    className?: string;
    customDuration: number;
    onMouseMove?: MouseEventHandler<HTMLDivElement>;
    onTouchMove?: TouchEventHandler<HTMLDivElement>;
    team: ITeamState;
}

type Props = IExternalProps;

class ControlComponent extends React.Component<Props> {

    constructor(props:any) {
        super(props);
        this.startFocus = this.startFocus.bind(this);
        this.startBreak = this.startBreak.bind(this);
    }

    public render() {
        const hidden = () => {
            const queryString = qs.parse(window.location.search);
            return queryString['?gui'] && queryString['?gui'] === 'hidden' ? 'hidden' : '';

        }

        return (
            <div
                className={ `${this.props.className} ${this.props.forceShow ? 'forceShow' : ''} ${hidden()}` }
                onMouseMove={ this.props.onMouseMove }
                onTouchMove={ this.props.onTouchMove }
            >
                <Button variant="outlined" onClick={ this.startFocus }  disabled={ this.props.disableStart }>
                    Start Focus
                    <PlayArrow/>
                </Button>
                <Button variant="outlined" onClick={ this.startBreak }>
                    Start Pause
                    <PlayArrow/>
                </Button>
                <Button variant="outlined" color="default" onClick={this.props.stopTimer} disabled={ this.props.disableStop }>
                    Stop Timer
                    <Stop/>
                </Button>
            </div>
        );
    }

    private startFocus():void {
        const duration = this.props.team.team!.settings.focus;
        this.props.startTimer( duration, 'Fokusphase');
    }

    private startBreak():void {
        const duration = this.props.team.team!.settings.pause;
        this.props.startTimer( duration, 'Verfügbar');
    }
}

export default styled(ControlComponent)`
    opacity: 0;
    animation-duration: 1s;
    animation-name: fadeout;

    &:hover, &.forceShow {
        opacity: 1;
        animation-duration: 1s;
        animation-name: fadein;
    }

    @keyframes fadein {
      from {
        opacity: 0;
      }

      to {
        opacity: 1;
      }
    }

    @keyframes fadeout {
      from {
        opacity: 1;
      }

      to {
        opacity: 0;
      }
    }

    display: flex;

    justify-content: center;

    button {
        border: 1px solid white;
        margin: 0px 8px 0px 8px;
    }

    button[disabled] {
        opacity: 0.5;
    }
    
    &.hidden {
      display: none;
    }
`;



// WEBPACK FOOTER //
// ./src/components/ControlComponent.tsx